var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinkSmile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint0_radial_2277_2542)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint1_radial_2277_2542)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint2_radial_2277_2542)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint3_radial_2277_2542)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint4_radial_2277_2542)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint5_radial_2277_2542)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint6_radial_2277_2542)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint7_radial_2277_2542)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9363 26.0703C21.7573 25.0847 22.2806 23.8855 22.4446 22.6131C22.6086 21.3408 22.4067 20.0481 21.8625 18.8864C21.3183 17.7247 20.4543 16.7422 19.3717 16.0539C18.2891 15.3656 17.0329 15 15.75 15C14.4672 15 13.2109 15.3656 12.1283 16.0539C11.0458 16.7422 10.1818 17.7247 9.63753 18.8864C9.0933 20.0481 8.89138 21.3408 9.05542 22.6131C9.21946 23.8855 9.74267 25.0847 10.5638 26.0703C11.7968 25.4508 13.6568 24.7503 15.7493 24.7503C17.8418 24.7503 19.7018 25.4508 20.9363 26.0703Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7974 25.5612C20.3785 24.9355 20.7696 24.1573 20.9249 23.3175C21.0803 22.4778 20.9935 21.6112 20.6746 20.819C20.3558 20.0267 19.8181 19.3416 19.1244 18.8436C18.4307 18.3455 17.6096 18.0551 16.757 18.0064C15.9044 17.9576 15.0556 18.1524 14.3096 18.5681C13.5636 18.9838 12.9513 19.6032 12.5442 20.3539C12.1371 21.1046 11.952 21.9556 12.0106 22.8076C12.0692 23.6596 12.3689 24.4773 12.8749 25.1652C13.8095 24.8942 14.7773 24.7543 15.7504 24.7497C17.2729 24.7497 18.6724 25.1202 19.7974 25.5612Z",
    fill: "url(#paint8_linear_2277_2542)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5004 21C29.3179 21 28.5724 22.3965 28.4554 22.863C28.4104 23.057 28.3272 23.2401 28.2107 23.4016C28.0942 23.5631 27.9468 23.6999 27.7769 23.8038C27.607 23.9077 27.4181 23.9767 27.2213 24.0069C27.0244 24.0371 26.8235 24.0277 26.6303 23.9794C26.4371 23.9311 26.2555 23.8448 26.096 23.7256C25.9365 23.6063 25.8023 23.4565 25.7013 23.2849C25.6003 23.1132 25.5345 22.9232 25.5078 22.7259C25.481 22.5285 25.4938 22.3278 25.5454 22.1355C25.9279 20.604 27.6829 18 31.5004 18C35.3179 18 37.0729 20.6025 37.4554 22.137C37.507 22.3293 37.5198 22.53 37.493 22.7274C37.4662 22.9247 37.4004 23.1147 37.2994 23.2864C37.1984 23.458 37.0643 23.6078 36.9048 23.7271C36.7453 23.8463 36.5636 23.9326 36.3704 23.9809C36.1772 24.0292 35.9763 24.0385 35.7795 24.0084C35.5826 23.9782 35.3938 23.9092 35.2239 23.8053C35.054 23.7014 34.9065 23.5646 34.79 23.4031C34.6735 23.2416 34.5904 23.0585 34.5454 22.8645C34.4284 22.395 33.6829 21 31.5004 21Z",
    fill: "url(#paint9_radial_2277_2542)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 12.75C31.5 12.5511 31.579 12.3603 31.7197 12.2197C31.8603 12.079 32.0511 12 32.25 12C33.411 12 34.863 12.426 36.1275 13.245C37.3995 14.07 38.5455 15.339 38.9775 17.0685C39.0205 17.2596 38.987 17.46 38.8842 17.6268C38.7814 17.7935 38.6174 17.9134 38.4273 17.9608C38.2373 18.0083 38.0362 17.9794 37.8671 17.8805C37.698 17.7816 37.5743 17.6204 37.5225 17.4315C37.2045 16.161 36.351 15.1785 35.31 14.5035C34.26 13.824 33.09 13.5 32.25 13.5C32.0511 13.5 31.8603 13.421 31.7197 13.2803C31.579 13.1397 31.5 12.9489 31.5 12.75Z",
    fill: "url(#paint10_linear_2277_2542)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1042 11.982C11.2132 12.825 10.6762 13.842 10.4602 14.487C10.432 14.5839 10.3845 14.674 10.3206 14.7521C10.2567 14.8301 10.1777 14.8945 10.0883 14.9413C9.99895 14.9882 9.90106 15.0165 9.8005 15.0246C9.69994 15.0327 9.59877 15.0204 9.50306 14.9885C9.40735 14.9566 9.31906 14.9057 9.24348 14.8389C9.16789 14.7721 9.10657 14.6907 9.06317 14.5996C9.01977 14.5085 8.9952 14.4096 8.99091 14.3089C8.98663 14.2081 9.00272 14.1074 9.03823 14.013C9.32323 13.158 9.98323 11.925 11.0707 10.893C12.1687 9.8505 13.7212 9 15.7492 9C15.9481 9 16.1389 9.07902 16.2796 9.21967C16.4202 9.36032 16.4992 9.55109 16.4992 9.75C16.4992 9.94891 16.4202 10.1397 16.2796 10.2803C16.1389 10.421 15.9481 10.5 15.7492 10.5C14.1772 10.5 12.9802 11.1495 12.1042 11.982Z",
    fill: "url(#paint11_linear_2277_2542)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24 39C13.5 39 13.5 28.5 13.5 28.5H34.5C34.5 28.5 34.5 39 24 39Z",
    fill: "url(#paint12_radial_2277_2542)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.221 30.75H13.779C13.5 29.436 13.5 28.5 13.5 28.5H34.5C34.5 28.5 34.5 29.436 34.221 30.75Z",
    fill: "url(#paint13_linear_2277_2542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2503 13.4994) rotate(132.839) scale(56.2549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2482 13.501) rotate(131.878) scale(58.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.999 18.7496) rotate(101.31) scale(26.7699 34.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 21) rotate(135) scale(61.5183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9999 25.5011) rotate(77.692) scale(42.2203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.75 24.75) rotate(55.713) scale(19.9702 14.4755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.75 27) rotate(9.86582) scale(17.5089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2501 22.5004) rotate(43.971) scale(88.5793)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2277_2542",
    x1: 19.9624,
    y1: 17.9997,
    x2: 17.1124,
    y2: 24.6132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5004 22.5) rotate(90) scale(6 8.78889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#4D274B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#514047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A342F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2277_2542",
    x1: 32.7495,
    y1: 18.6,
    x2: 32.7495,
    y2: 15.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2277_2542",
    x1: 10.2487,
    y1: 15.6,
    x2: 10.2487,
    y2: 12.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#524049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2C42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2277_2542",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 41.334) rotate(-90) scale(12.8333 25.6667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2277_2542",
    x1: 24,
    y1: 28.5,
    x2: 24,
    y2: 30.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinkSmile1);
export default __webpack_public_path__ + "static/media/Wink Smile 1.0ff7faad1099cba9318ed268dbc354cb.svg";
export { ForwardRef as ReactComponent };